<div class="basin-display-flex basin-flex-column">
  <div
    *ngFor="let item of trackerDetails; let last = last" [ngClass]="{ 'basin-pt-2': last, 'basin-py-2': !last }"
    class="basin-display-flex basin-align-items-center basin-flex-row basin-justify-content-space-between basin-color-dark-gray basin-font-size-14 basin-line-height-18"
  >
    <div class="basin-display-flex basin-align-items-center">
      <div>{{ item.label }}</div>
      <div *ngIf="item.tooltip" class="symbol-info tooltip-icon basin-pl-1 basin-color-light-gray" [pTooltip]="item.tooltip"></div>
    </div>

    <div>{{ item.value }}</div>
  </div>
</div>
